import {
  http
} from '../../config';
import base from '../base';

export const feedback={
  getFeedbackList(data){
    return http({
      url:`${base.users}/teacherProxy/queryStudentFeedbackList`,
      method:'post',
      data
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/agent-api/feedback.js